import styles from "./styles.module.scss"
import { observer } from "mobx-react-lite"
import { match } from "ts-pattern"
import { toJS } from "mobx"
import { useQuery } from "@tanstack/react-query"
import { useStores } from "../../../models/helpers/useStores"
import { getCruiseSearchResult } from "../../../services/firestore/cruiseSearchResult"
import BookedCruiseCard from "../../cards/BookedCruiseCard"
import BookedCruiseCardSkeleton from "../../loaders/BookedCruiseCardSkeleton"
import CruiseIcon from "../../assets/icons/CruiseIcon"
import { getISOString } from "../../../utils/dates"

const BookedCruise = observer(({ tripId }: { tripId: string }) => {
  const rootStore = useStores()
  const { activeTrip, cruiseDetailsPlaceholderData } = rootStore

  const currentTripId = tripId || activeTrip.id

  const { data, status } = useQuery({
    queryKey: ["cruiseSearchResult", currentTripId, activeTrip.chosenTripSearchResultId],
    queryFn: () => getCruiseSearchResult(currentTripId, activeTrip.chosenTripSearchResultId),
    enabled: currentTripId !== "" && activeTrip.chosenTripSearchResultId !== "",
  })

  return (
    <>
      <div className={styles.bookedCruiseHeading}>
        <CruiseIcon />
        <h1>Cruise</h1>
      </div>
      <div className={styles.bookedCruiseContainer}>
        <>
          {match(status)
            .with("pending", () => <BookedCruiseCardSkeleton />)
            .with("error", () => null)
            .when(
              (currentStatus) => currentStatus === "success" && data !== null,
              () => (
                <BookedCruiseCard
                  cruise={{
                    image: data.cruiseSearchResult.heroImage,
                    lineLogoImage: data.cruiseSearchResult.lineLogo,
                    lineName: data.cruiseSearchResult.lineName,
                    name: data.cruiseSearchResult.name,
                    startDate: data.cruiseSearchResult.startDate,
                    endDate: data.cruiseSearchResult.endDate,
                    ports: data.cruiseSearchResult.ports,
                  }}
                  onClick={() => {
                    if (cruiseDetailsPlaceholderData?.id === data.cruiseSearchResult.id) {
                      rootStore.setProp("cruiseDetailsPlaceholderData", null)
                    } else {
                      rootStore.setProp(
                        "cruiseDetailsPlaceholderData",
                        toJS({
                          id: data.cruiseSearchResult.id,
                          name: data.cruiseSearchResult.name,
                          lowestPrice: data.cruiseSearchResult.lowestPrice,
                          lowestPricePP: data.cruiseSearchResult.lowestPricePP,
                          startDate: getISOString(data.cruiseSearchResult.startDate),
                          endDate: getISOString(data.cruiseSearchResult.endDate),
                          likes: data.cruiseSearchResult.likes,
                          lineLogo: data.cruiseSearchResult.lineLogo,
                          lineName: data.cruiseSearchResult.lineName,
                          imageUrl: data.cruiseSearchResult.heroImage,
                        }),
                      )
                    }
                  }}
                />
              ),
            )
            .otherwise(() => null)}
        </>
      </div>
    </>
  )
})

export default BookedCruise
